import api from './base/standardApi';

export default {

  getInvestmentAccounts( params?:any | undefined ) {
    return api.get( 'api/cuentadeinversion', params );
  },
  getActiveInvestmentAccounts( id: number ) {
    return api.put( `api/cuentadeinversion/Activar/${id}` );
  },
  getSincronizarSolicitudDoc( id: number ) {
    return api.get( `api/cuentadeinversion/SincronizarSolicitudDoc/${id}` );
  },
  getSyncSolicitudDocStatus( id: number, params:any = {} ) {
    return api.get( `api/cuentadeinversion/sync-solicituddoc/status/${id}`, params );
  },
  getSyncSolicitudDocLogs( id: number, params:any = {} ) {
    return api.get( `api/cuentadeinversion/sync-solicituddoc/logs/${id}`, params );
  },
  getDisableInvestmentAccounts( id: number ) {
    return api.put( `api/cuentadeinversion/Desactivar/${id}` );
  },
  getInvestmentGetPersonal( id: number ) {
    return api.get( `api/cuentadeinversion/GetPersonal/${id}` );
  },
  getInvestmentGetEmpresa( id: number ) {
    return api.get( `api/cuentadeinversion/GetEmpresa/${id}` );
  },
  getAllBackOffice( params:any, config:any = {} ) {
    return api.get( 'api/cuentadeinversion/GetAllBackOffice', params, config );
  },
  getAllByPromocionBackOffice( params:any, config:any = {} ) {
    return api.get( 'api/cuentadeinversion/GetAllByPromocionBackOffice', params, config );
  },
};
